import { getHostApis } from './getHost'
import debug from '../../utils/console'

const logger = debug.withTag('utils:host-browser-apis:openInDefaultBrowser')

export async function openInDefaultBrowser(url: string): Promise<void> {
  const { shift, onelaunch } = getHostApis()

  try {
    const shiftAPI = shift?.ntp?.openInDefaultBrowser
    if (shiftAPI) {
      await shiftAPI(url)
      return
    }

    const onelaunchAPI = onelaunch?.openInDefaultBrowser
    if (onelaunchAPI) {
      await onelaunchAPI(url)
      return
    }
  } catch (error) {
    logger.error('Failed to open in default browser', error)
  }

  // fallback - for non-browser users or error on host API
  window.open(url, '_blank')
}
